var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Subject } from 'rxjs';
import { AutoRenameTypeEnum } from '../../data-configuration/configuration/variable/batch-import-modal/auto-rename-type-enum';
import { Component, ViewChild } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { finalize } from 'rxjs/operators';
var RenameVariableOrAlarmModalComponent = /** @class */ (function (_super) {
    __extends(RenameVariableOrAlarmModalComponent, _super);
    function RenameVariableOrAlarmModalComponent(injector, bsModalRef, dataSourceService) {
        var _this = _super.call(this, injector) || this;
        _this.bsModalRef = bsModalRef;
        _this.dataSourceService = dataSourceService;
        _this.importing = false;
        _this.enumAutoRenameType = AutoRenameTypeEnum;
        _this.selectedRenameRule = AutoRenameTypeEnum.NameGroupNameDataSourceName;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(RenameVariableOrAlarmModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    RenameVariableOrAlarmModalComponent.prototype.import = function () {
        var _this = this;
        this.importing = true;
        this.buildDataAfterImportDto.renameType = this.selectedRenameRule.valueOf();
        this.dataSourceService.buildDataAfterImport(this.buildDataAfterImportDto)
            .pipe(finalize(function () { return _this.importing = false; }))
            .subscribe(function () {
            _this.close();
        });
    };
    RenameVariableOrAlarmModalComponent.prototype.close = function (item) {
        this._onClosed.next(item);
        this._onClosed.complete();
        this.importing = false;
        this.bsModalRef.hide();
        this.selectedRenameRule = AutoRenameTypeEnum.NameGroupNameDataSourceName;
    };
    __decorate([
        ViewChild('rename', { static: false })
    ], RenameVariableOrAlarmModalComponent.prototype, "modal", void 0);
    RenameVariableOrAlarmModalComponent = __decorate([
        Component({
            selector: 'rename-variable-or-alarm-modal',
            template: "<div class=\"fe-modal-container\"> <form #renameForm=\"ngForm\" novalidate (ngSubmit)=\"import()\"> <div class=\"fe-modal-header\"> <h4 class=\"modal-title fe-modal-header-title\"> <span>{{lc(\"AutoRename\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\"> <div class=\"rule-tips\"> <label>{{lc('AutoRenameRule')}}</label> </div> <div class=\"rule-select\"> <label>{{lc('ConfigureVariableOrAlarmName')}}</label> <span> = </span> <select name=\"renameRule\" [(ngModel)]=\"selectedRenameRule\"> <option [ngValue]=\"enumAutoRenameType.NameGroupNameDataSourceName\" selected> {{lc('DataSource_NameGroupNameDataSourceName')}}</option> <option [ngValue]=\"enumAutoRenameType.AutoIncrement\"> {{lc('VariableOrAlarmNameAutoIncrease')}}</option> </select> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!renameForm.form.valid||importing\" [buttonBusy]=\"importing\" [busyText]=\"l('SavingWithThreeDot')\"> {{lc(\"Confirm\")}} </button> <button [disabled]=\"importing\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div>",
            styles: [".modal-body { padding-left: 50px; .rule-tips { margin-bottom: 12px; } .rule-select { display: inline-block; vertical-align: middle; height: 31px; label { height: 20px; } select { height: 31px; } } } .fe-modal-container .fe-modal-header { border-bottom: 1px solid #f4f4f4; .fe-modal-header-title { line-height: 50px; } } "],
        })
    ], RenameVariableOrAlarmModalComponent);
    return RenameVariableOrAlarmModalComponent;
}(ConfigureComponentBase));
export { RenameVariableOrAlarmModalComponent };
